export default "__VITE_ASSET__SgYf1wr8__"